import { useState, useEffect, useCallback } from 'react';
import { monitoringService } from '@/services/monitoring.service';
import type { Pdf, Extraction, MonitoringLog, MonitoringStats } from '@/types';

export const useMonitoring = () => {
  const [pdfs, setPdfs] = useState<Pdf[]>([]);
  const [extractions, setExtractions] = useState<Extraction[]>([]);
  const [history, setHistory] = useState<MonitoringLog[]>([]);
  const [stats, setStats] = useState<MonitoringStats | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchAll = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const [pdfsData, extractionsData, historyData, statsData] = await Promise.all([
        monitoringService.getPdfs(),
        monitoringService.getExtractions(),
        monitoringService.getMonitoringHistory(),
        monitoringService.getMonitoringStats(),
      ]);
      setPdfs(pdfsData);
      setExtractions(extractionsData);
      setHistory(historyData);
      setStats(statsData);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch monitoring data');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  return { pdfs, extractions, history, stats, loading, error, refetch: fetchAll };
};
